import { render, staticRenderFns } from "./land-around.vue?vue&type=template&id=1772aebf"
import script from "./land-around.vue?vue&type=script&lang=js"
export * from "./land-around.vue?vue&type=script&lang=js"
import style0 from "./land-around.vue?vue&type=style&index=0&id=1772aebf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports